<template>
	<section>
		<slot :name="searchStore.searchType">
		</slot>
	</section>
</template>

<script setup lang="ts">
import { useSearchStore } from '@stores/useSearchStore';

const searchStore = useSearchStore();
</script>
